var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-file-upload", {
    attrs: {
      "max-size": 25000000,
      "allowed-extensions": _vm.allowedExtensions,
      label: _vm.$ct("upload-file"),
    },
    on: {
      input: function ($event) {
        return _vm.onFile($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }